'use strict';

angular.module('amexReconciliationApp')
  .directive('matchReceiptButton', function () {
    return {
      template: '<button class="btn btn-primary btn-width-large match-receipt" ' +
      'title="Match" ' +
      'ng-click="matchReceipt()">' +
      '<span translate>receipt.Match</span>' +
      '</button>',
      scope: {
        receipt: '=',
        onSuccess: '&',
        onFailure: '&',
        successMessage: '@',
        errorMessage: '@',
        transactions: '&'
      },
      controller: function ($scope,
                            $translate,
                            toastr,
                            TransactionReceiptService) {

        $scope.matchReceipt = function matchReceipt() {
          var transactions = $scope.transactions();
          var receipt = $scope.receipt;

          TransactionReceiptService.matchReceiptsToTransactions([receipt], transactions)
            .then(function () {
              $scope.onSuccess();
              toastr.success($scope.successMessage);
            })
            .catch(function () {
              $scope.onFailure();
              toastr.error($scope.errorMessage);
            });

        };
      }
    };
  });



//////////////////
// WEBPACK FOOTER
// ./src/main/resources/static/scripts/directives/matchReceiptButton.js
// module id = 526
// module chunks = 0